/**
 * @copyright 2021 @ DigiNet
 * @author ANHTAI
 * @create 20/01/2021
 * @update 04/03/2021
 * @file src/components/header/header.js
 */

import { Column } from "devextreme-react/data-grid";
import uniqBy from "lodash/uniqBy";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import * as w17f2030Actions from "../../actions/w17/w17F2030/w17F2030-actions";
import Config from "../../config";
import GridContainer from "../common/grid-container/grid-container";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, NumberInput } from 'diginet-core-ui/components';
import { makeStyles } from "diginet-core-ui/theme";
import { Loading } from "../common/loading/loadingCore";

const useStyles = makeStyles({
    moneyInputColumn: {
        width: '100%',
        '& input': {
            textAlign: 'right'
        }
    }
});
class W17F2030 extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            modalLoaded: false,
            dataGrid: [],
            totalDataGrid: 0,
            selectedRowKeys: [],
            selectedRowData: []
        };
        this.tmpSelectedRowData = [];
        this.tmpSelectedRowKeys = [];
        this.changePage = false;
        this.filter = {
            Language: Config.language || "84",
            FormID: "W17F2000",
            Type: "AddQuotation",
            DataType: "GridInventoryID",
            DivisionID: "",
            ObjectID: "",
            PriceListID: "",
            CurrencyID: "",
            TranTypeID: "",
            WareHouseID: "",
            IsQuotationNoneCode: 0,
            limit: 50,
            skip: 0,
            search: ""
        }
    }

    componentDidMount = async () => {
        const { divisionID, priceListID, objectID, currencyID, tranTypeID, paymentTermID, paymentMethodID, isQuotationNoneCode, wareHouseID } = this.props;
        this.filter.DivisionID = divisionID;
        this.filter.PriceListID = priceListID;
        this.filter.ObjectID = objectID;
        this.filter.CurrencyID = currencyID;
        this.filter.TranTypeID = tranTypeID;
        this.filter.PaymentTermID = paymentTermID;
        this.filter.PaymentMethodID = paymentMethodID;
        this.filter.IsQuotationNoneCode = isQuotationNoneCode;
        this.filter.WareHouseID = wareHouseID;
        this.loadGrid(true);
    };


    loadGrid = (isFirstLoad = false) => {
        if (!isFirstLoad) {
            this.changePage = true;
        };
        const { search, limit, skip, DivisionID, Language, Type, DataType, ObjectID, PriceListID, CurrencyID,
            TranTypeID, FormID, PaymentTermID, PaymentMethodID, IsQuotationNoneCode, WareHouseID
        } = this.filter;
        const params = {
            FormID,
            Type,
            DivisionID,
            Language,
            DataType,
            ObjectID,
            PriceListID,
            CurrencyID,
            TranTypeID,
            PaymentTermID,
            PaymentMethodID,
            IsQuotationNoneCode,
            WareHouseID,
            skip,
            limit,
            search
        };
        this.setState({ modalLoaded: true });
        this.props.w17f2030Actions.loadDataInventory(params, (errors, data) => {
            if (errors) {
                this.setState({ modalLoaded: false })
                Config.popupCore.show('ERROR', errors);
                return false;
            }
            else if (data && data.rows) {
                if (this.props.selectedRow && isFirstLoad) this.tmpSelectedRowKeys = this.props.selectedRow;
                this.setState({
                    modalLoaded: false,
                    dataGrid: data.rows ? data.rows : data,
                    totalDataGrid: data.total
                });
            }
        });
    };

    onChangePage = (page) => {
        this.filter.skip = page * this.filter.limit;
        this.loadGrid();
    };

    onChangePerPage = (per) => {
        this.filter.skip = 0;
        this.filter.limit = per;
        this.loadGrid();
    };

    handleChecked = (currentSelectedRowKeys, keyExpr, mode) => {
        currentSelectedRowKeys.forEach((val) => {
            if (this.tmpSelectedRowKeys.indexOf(val[keyExpr]) < 0) {
                this.tmpSelectedRowData.push(val);
                this.tmpSelectedRowKeys.push(val[keyExpr]);
            }
        });
    }

    handleUnChecked = (currentDeselectedRowKeys, keyExpr) => {
        this.tmpSelectedRowData = this.tmpSelectedRowData.filter((e) => {
            return currentDeselectedRowKeys.indexOf(e[keyExpr]) < 0;
        });
        this.tmpSelectedRowKeys = this.tmpSelectedRowKeys.filter((e) => {
            return currentDeselectedRowKeys.indexOf(e) < 0;
        });
    }

    onSelectionChanged = (e) => { // Fix bug chuyển trang mấy check lần đầu tiên
        const keyExpr = "InventoryID";
        let currentSelectedRowKeys = e.selectedRowsData;
        const currentDeselectedRowKeys = e.currentDeselectedRowKeys;
        if (this.changePage) {
            if (currentSelectedRowKeys.length > 0) {
                this.handleChecked(currentSelectedRowKeys, keyExpr);
            }
            this.changePage = false;
        } else {
            if (currentDeselectedRowKeys.length > 0) {// UnSelect
                this.handleUnChecked(currentDeselectedRowKeys, keyExpr);
            }
            else if (currentSelectedRowKeys.length > 0) {
                this.handleChecked(currentSelectedRowKeys, keyExpr);
            }
        }
        this.setState({ selectedRowData: [...this.tmpSelectedRowData] });
    }

    reLoadGrid = () => {
        const { isW17F2040, divisionID, paymentTermID, paymentMethodID } = this.props;
        let reloadApiName = "reLoadGrid";
        if (isW17F2040) reloadApiName = "reLoadGridW17F2040";
        const params = {
            DivisionID: divisionID,
            Language: this.filter.Language,
            PaymentTermID: paymentTermID || "",
            PaymentMethodID: paymentMethodID || ""
        };
        this.props.w17f2030Actions[reloadApiName](params, (errors, data) => {
            this.setState({ modalLoaded: false });
            if (errors) {
                let message = errors.message || Config.lang("CRM_Loi_chua_xac_dinh");
                Config.popupCore.show("INFO", message);
                return false;
            } else if (data) {
                this.handleSaveAndClose(data);
            }
        });
    }

    handleSaveAndClose = (data) => {
        const dataGridPlus = [...this.props.dataGridMaster, ...data];
        this.tmpSelectedRowKeys = [...new Set(this.tmpSelectedRowKeys)]; // Những thằng check hiện tại
        if (this.props.getAll) {
            const dataF = dataGridPlus.filter(rs => {
                return (rs.IsSelect === undefined && this.tmpSelectedRowKeys.find(item => item === rs.InventoryID)) || rs.__KEY__ !== undefined || !rs.InventoryID;
            });
            if (this.props.onClose) this.props.onClose(dataF, this.tmpSelectedRowKeys);
        } else {
            let unSelectKey = []; // Những thằng bị bỏ check
            let removeUnSelectKeyData = [];
            // Đã thâm vô rồi nhé nhưng mà những thằng mình bỏ check thì sao cậu
            const dataGridMasterKey = dataGridPlus.map(item => item.InventoryID);
            const allTmpSelectedRowKeys = [...new Set(dataGridMasterKey.concat(this.tmpSelectedRowKeys))]; // All tất cả các key
            allTmpSelectedRowKeys.forEach(item => { // Những thằng bỏ check
                if (this.tmpSelectedRowKeys.indexOf(item) < 0) {
                    unSelectKey.push(item);
                }
            })
            if (!Config.isEmpty(unSelectKey)) {
                removeUnSelectKeyData = dataGridPlus.filter((obj) => this.tmpSelectedRowKeys.some((InventoryID) => obj.InventoryID === InventoryID));
            } else {
                removeUnSelectKeyData = dataGridPlus;
            }
            const uniqueSelectKeyData = uniqBy(removeUnSelectKeyData, e => e.InventoryID); // KIểm tra lần nữa loại bỏ trùng
            if (this.props.onClose) this.props.onClose(uniqueSelectKeyData, this.tmpSelectedRowKeys);
        }
    }

    onChoseIventory = () => {
        const { selectedRowData } = this.state;
        const { divisionID, tranTypeID, priceListID, objectID, currencyID, dataGridMaster } = this.props;
        // Loại bỏ những thằng đã có ở lưới hàng hóa
        const selectedRowDataUnique = selectedRowData.filter((obj) => !dataGridMaster.some((obj2) => obj.InventoryID === obj2.InventoryID));
        if (!Config.isEmpty(selectedRowDataUnique)) {
            selectedRowDataUnique.forEach(item => {
                item["Type"] = this.filter.Type;
                item["DataType"] = this.filter.DataType;
                item["ObjectID"] = objectID;
                item["DivisionID"] = divisionID;
                item["CurrencyID"] = currencyID;
                item["TranTypeID"] = tranTypeID;
                item["PriceListID"] = priceListID;
            })
            const params = {
                FormID: this.props.formID,
                data: JSON.stringify(selectedRowDataUnique)
            };
            this.setState({ modalLoaded: true })
            this.props.w17f2030Actions.saveW17F2030(params, (errors, data) => {
                if (errors) {
                    this.setState({ modalLoaded: false });
                    Config.popupCore.show('ERROR', errors);
                    return false;
                } else if (!Config.isEmpty(data)) {
                    if (data.Status === 0) {  //Lưu thành công chạy api để lấy data vừa lưu ra
                        this.reLoadGrid();
                    } else if (data?.Message) Config.popupCore.show("INFO", data.Message);
                }
            });
        } else {
            this.handleSaveAndClose(selectedRowData);
        }
    }

    onHide = () => {
        if (this.props.onClose) this.props.onClose();
    }

    onSearch = (e) => {
        this.filter.search = e;
        this.loadGrid();
    };

    renderNumberFormat = (e, mode = 'view') => {
        if (!e) return false;
        const classes = useStyles();
        return <NumberInput
            nonStyle
            readOnly={mode !== 'edit'}
            value={e?.value}
            decimalDigit={8}
            thousandSeparator={','}
            className={classes.moneyInputColumn}
        />
    };

    render() {
        const { listPerPage, mode, openModal } = this.props;
        const { dataGrid, totalDataGrid, modalLoaded } = this.state;
        return (
            <Modal open={openModal} size={'xl'} onClose={() => this.onHide()}>
                <ModalHeader title={Config.lang('Thong_tin_hang_hoa')} />
                <ModalBody style={{ minHeight: 500 }}>
                    <Loading visible={modalLoaded} />
                    <GridContainer
                        totalItems={totalDataGrid}
                        itemPerPage={this.filter.limit}
                        skipPerPage={this.filter.skip}
                        dataSource={dataGrid}
                        keyExpr={"InventoryID"}
                        gridProps={{
                            style: { maxHeight: 420 }
                        }}
                        pagerFullScreen={false}
                        showBorders={false}
                        columnAutoWidth={true}
                        typeShort={window.innerWidth < 768}
                        height={"calc(100vh - 180px)"}
                        selection={{
                            allowSelectAll: mode === "multiple",
                            mode: "multiple",
                            selectAllMode: "",
                            showCheckBoxesMode: "always"
                        }}
                        onSearch={this.onSearch}
                        allowColumnResizing={true}
                        listPerPage={listPerPage}
                        selectedRowKey={this.tmpSelectedRowKeys}
                        onChangePage={this.onChangePage}
                        onChangePerPage={this.onChangePerPage}
                        onSelectionChanged={(e) => this.onSelectionChanged(e)}
                    >
                        <Column
                            width={200}
                            dataField={"InventoryID"}
                            caption={Config.lang("CRM_Ma_hang")}
                            allowEditing={false} />
                        <Column
                            minWidth={250}
                            dataField={"InventoryName"}
                            caption={Config.lang("CRM_Ten_hang_hoa")}
                            allowEditing={false} />
                        <Column
                            width={150}
                            dataField={"TypeInventoryID"}
                            caption={Config.lang("CRM_Loai_hang_hoa")}
                            allowEditing={false} />
                        <Column
                            width={150}
                            dataField={"UnitID"}
                            caption={Config.lang("CRM_DVT")}
                            allowEditing={false} />
                        <Column
                            width={150}
                            dataField={"UnitPriceOnD14"}
                            dataType={'number'}
                            caption={Config.lang("CRM_DG_goc")}
                            allowEditing={false}
                            cellRender={this.renderNumberFormat}
                        />
                        <Column
                            width={150}
                            dataField={"DefaultOQuantityMOQ"}
                            dataType={'number'}
                            caption={Config.lang("So_luong_toi_thieu")}
                            allowEditing={false}
                            cellRender={this.renderNumberFormat}
                        />
                        <Column
                            width={150}
                            dataField={"BalanceQTY"}
                            dataType={'number'}
                            caption={Config.lang("So_luong_ton")}
                            allowEditing={false}
                            cellRender={this.renderNumberFormat}
                        />
                        <Column
                            width={150}
                            dataField={"ShipDateNumIn"}
                            caption={Config.lang("Thoi_gian_giao_hang")}
                            allowEditing={false}
                        />
                        {/* <Column
                                  width={150}
                                  dataField={"Quantity"}
                                  caption={Config.lang("CRM_So_luong")}
                                  dataType={"number"}
                              /> */}
                    </GridContainer>
                </ModalBody>
                <ModalFooter>
                    <div className={'jus-end'}>
                        <Button
                            color={'info'}
                            viewType={'filled'}
                            label={Config.lang('Chon')}
                            disabled={Config.isEmpty(this.tmpSelectedRowKeys)}
                            onClick={() => this.onChoseIventory()}
                        />
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

W17F2030.propTypes = {
    openModal: PropTypes.bool,
    maxWidth: PropTypes.string,
    formID: PropTypes.string,
    objectID: PropTypes.string,
    divisionID: PropTypes.string,
    priceListID: PropTypes.string,
    currencyID: PropTypes.string,
    tranTypeID: PropTypes.string,
    wareHouseID: PropTypes.string,
    isQuotationNoneCode: PropTypes.number,
    selectedRow: PropTypes.array,
    dataGridMaster: PropTypes.array,
    onClose: PropTypes.func
};

W17F2030.defaultProps = {
    mode: 'multiple',
    openModal: false,
};

export default compose(connect(null, (dispatch) => ({
    w17f2030Actions: bindActionCreators(w17f2030Actions, dispatch),
})))(W17F2030);
